export default [
  {
    path: '/interessados',
    name: 'interessados',
    component: () => import(/* webpackChunkName: "interessados" */ './Interessados'),
    children: [
      {
        path: '/interessados/consulta',
        name: 'consultaInteressados',
        components: {
          manageInteressadoRouter: () => import(/* webpackChunkName: "interessados" */ '@/components/manter-processo/contatoExterno/consultar/ConsultarContatoExterno')
        }
      }, {
        path: '/interessados/manter',
        name: 'manterInteressados',
        components: {
          manageInteressadoRouter: () => import(/* webpackChunkName: "interessados" */ '@/components/manter-processo/contatoExterno/manter/ManterContatoExterno')
        }
      }
    ]
  }
]
